import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/login-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useVisitorData } from '@fingerprint/react';
import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { getVisitorID } from '../../api/authentication.ts';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function Login() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const { getData } = useVisitorData({ immediate: false });

  const getFingerprint = async (): Promise<string | undefined> => {
    let fingerprint = localStorage.getItem('ffm_fingerprint');

    if (!fingerprint) {
      const result = await getData();
      const visitorId = await getVisitorID(result.event_id);
      fingerprint = visitorId.data.id;

      localStorage.setItem('ffm_fingerprint', visitorId.data.id);
    }

    if (!fingerprint) {
      return undefined;
    }

    return fingerprint;
  };

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email_address: '',
      password: '',
    },
    validate: {
      email_address: (value) => (/^\S+@\S+$/.test(value) ? null : FORM_ERRORS.EMAIL_INVALID),
    },
  });

  form.watch('email_address', () => {
    form.clearErrors();
  });

  form.watch('password', () => {
    form.clearErrors();
  });

  useEffect(() => {
    if (isLoggedIn && auth.details && auth.details['username'] !== undefined) {
      navigate(`/${auth.details['username']}`);
    } else if (isLoggedIn) {
      navigate(LINKS.HOME);
    }
  }, [isLoggedIn, auth.details, navigate]);

  const handleSubmit = (values: typeof form.values) => {
    getFingerprint().then((fp) => {
      auth
        .login(
          {
            email: values.email_address,
            password: values.password,
          },
          getFingerprint,
          fp,
        )
        .then(() => {
          setIsLoggedIn(true);
        })
        .catch((error) => {
          if (error.errorType === 'UNAUTHORISED') {
            form.setErrors({
              email_address: ' ',
              password: 'Your email address or password is incorrect',
            });
          } else {
            form.setErrors({
              email_address: ' ',
              password: 'There was an issue processing your request. Please try again.',
            });
          }
        });
    });
  };

  return <Screen form={form} handleSubmit={handleSubmit} />;
}

export default Login;
